<template>
  <b-modal
    ref="bModal"
    no-fade
    modal-class="modalIncidentList"
    style="z-index:0"
    hide-footer
    hide-backdrop
  >
    <template slot="modal-title">
      <div class="d-flex flex-column">
        <span qa="modal-incident-list-label">
          <i
            v-if="type"
            class="main mr-1"
            :class="portionTypes[type].icon"
            aria-hidden="true"
          />
          {{ label }}
        </span>
      </div>
    </template>
    <div
      class="incident-list-content"
    >
      <div
        v-if="openIncidents.length"
        qa="modal-incident-list-open-content"
      >
        <b-row class="px-3 mt-4 mb-2">
          <b-col>
            <span class="mt-2 primary-dark-color font-weight--medium">{{ $tc('global.incident', 2) }}</span>
          </b-col>
        </b-row>
        <b-row
          v-for="(incident, index) in openIncidents"
          :key="index"
          class="px-3 mt-2 mb-3"
          qa="modal-incident-list-open-incident-wrapper"
        >
          <b-col>
            <b-card
              class="incident-card float-component"
              qa="modal-incident-list-open-incident-card"
              @click="showIncidentFormModal(incident.incidentId, incident.incLabel)"
            >
              <b-row>
                <b-col>
                  <b-row class="mt-2">
                    <b-col>
                      <span
                        qa="modal-incident-list-open-incident-label"
                        class="ap-title__section font-weight--medium primary-dark-color"
                      >{{ incident.incLabel }}</span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col
                      cols="4"
                      class="pr-0"
                    >
                      <small>{{ $t('component.incidentModal.date') }}</small>
                      <h5 class="card-info">
                        {{ incident.openingDate | datetime }}
                      </h5>
                    </b-col>
                    <b-col cols="8">
                      <small>{{ $t('component.incidentModal.type') }}</small>
                      <h5 class="card-info">
                        {{ incident.incidentType.name }}
                      </h5>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col
                  cols="auto"
                  class="d-flex align-items-center justify-content-end"
                >
                  <i
                    class="fal fa-arrow-right main"
                    aria-hidden="true"
                    @click="showIncidentFormModal(incident.incidentId, incident.incLabel)"
                  />
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </div>
      <div
        v-if="closedIncidents.length"
        qa="modal-incident-list-close-content"
      >
        <b-row class="px-3 mt-4">
          <b-col>
            <span class="primary-dark-color font-weight--medium">{{ $t('component.incidentModal.closedIncidents') }}</span>
          </b-col>
        </b-row>
        <b-row
          v-for="(incident, index2) in closedIncidents"
          :key="index2"
          class="px-3 mt-2 mb-3"
          qa="modal-incident-list-close-incident-wrapper"
        >
          <b-col>
            <b-card
              class="incident-card float-component close-incident"
              qa="modal-incident-list-close-incident-card"
              @click="showIncidentFormModal(incident.incidentId, incident.incLabel)"
            >
              <b-row>
                <b-col>
                  <b-row class="mt-2">
                    <b-col>
                      <span
                        qa="modal-incident-list-close-incident-label"
                        class="ap-title__section font-weight--medium primary-dark-color"
                      >{{ incident.incLabel }}</span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col
                      cols="4"
                      class="pr-0"
                    >
                      <small>{{ $t('component.incidentModal.date') }}</small>
                      <h5 class="card-info">
                        {{ incident.openingDate | datetime }}
                      </h5>
                    </b-col>
                    <b-col cols="8">
                      <small>{{ $t('component.incidentModal.type') }}</small>
                      <h5 class="card-info">
                        {{ incident.incidentType.name }}
                      </h5>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col
                  cols="auto"
                  class="d-flex align-items-center justify-content-end"
                >
                  <i
                    class="fal fa-arrow-right main"
                    aria-hidden="true"
                    @click="showIncidentFormModal(incident.incidentId, incident.incLabel)"
                  />
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </div>
  </b-modal>
</template>

<script>
import IncidentServices, { COREENTITY_VALUES } from '@/api/resources/incident/incidentServices'
import { PORTION_TYPES } from '@/api/resources/portionTypeService'
export default {
    name: 'ModalIncidentList',
    props: {
        idValue: String
    },
    data() {
        return {
            openIncidents: [],
            closedIncidents: [],
            coreEntity: null,
            entitiesIds: null,
            label: '',
            type: null,
            portionTypes: PORTION_TYPES,
            elementSelected: {}
        }
    },
    computed: {
        labId() {
            return this.$store.getters.labId
        },
        isModalOpen() {
            return this.$refs.bModal.is_show
        }
    },
    methods: {
        showIncidentFormModal(incidentId, incidentLabel) {
            this.$emit('openIncidentFormModal', {
                coreEntity: this.coreEntity,
                entitiesIds: this.entitiesIds,
                incidentId,
                incidentLabel,
                elementSelected: this.elementSelected
            })
            this.hide()
        },
        hide() {
            this.$refs.bModal.hide()
        },
        async loadIncidents() {
            this.updateLoading(true)
            let error, response
            switch (this.coreEntity) {
            case COREENTITY_VALUES.PORTION.code:
                [error, response] = await this.toCall(IncidentServices.getPortionIncidents(this.labId,
                    ...this.entitiesIds))
                break
            case COREENTITY_VALUES.SUBPORTION.code:
                [error, response] = await this.toCall(IncidentServices.getSubportionsIncidents(this.labId,
                    ...this.entitiesIds))
                break
            }
            this.updateLoading(false)
            if (error || !response) {
                this.showErrorModalGlobal()
                return
            }
            this.openIncidents = response.filter(incident => !incident.closingDate)
            this.closedIncidents = response.filter(incident => incident.closingDate)
        },
        async show(coreEntity, entitiesIds, elementSelected) {
            this.label = elementSelected.porLabel || elementSelected.supLabel
            this.type = elementSelected.portionTypeKeyEnum
            this.elementSelected = elementSelected
            this.coreEntity = coreEntity
            this.entitiesIds = entitiesIds
            await this.loadIncidents()
            this.showModal()
        },
        showModal() {
            this.$refs.bModal.show()
        }
    }
}
</script>

<style lang="scss">
.modalIncidentList .modalIncidentForm .modal-content {
  box-shadow: none;
}

.modalIncidentList .close-incident{
  border: 1px solid vt-color(light-grey) !important;
  opacity: .7;
}
.modalIncidentList .card{
  border: 1px solid vt-color(red-medium, .4);
}

.modalIncidentList .incident-list-content{
  height: calc(100vh - 170px);
  overflow-y:auto;
  overflow-x: hidden;
}
.modalIncidentList .card-info{
  font-size: font-size(small);
}

.modalIncidentList .mx-input{
  height: calc(1.5em + 0.5rem + 9px) !important;
}

.modalIncidentList textarea.form-control {
  height: 70px !important;
}

.modalIncidentList .tracking-tabs .nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  background-color: transparent;
  color: vt-color(primary);
  border-radius: 0;
}

.modalIncidentList .nav-link.disabled{
  opacity: .5;
}

.modalIncidentList .tracking-tabs .nav-link.active {
  position: relative;
}

.modalIncidentList .tracking-tabs .nav-link.active i {
  color: vt-color(primary);
}

.modalIncidentList .tracking-tabs .nav-link.active:before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  border-radius: 2px 2px 0 0;
  width: 90%;
  height: 5px;
  background: vt-color(primary);
  bottom: 0;
}

.modalIncidentList .nav-item {
  border-bottom: 0.5px solid rgb(184, 184, 184) !important;
}

.modalIncidentList .nav-item i {
  color: vt-color(base-text);
  font-size: font-size(big);
}

.modalIncidentList .nav-link {
  padding: 0.7rem 1rem;
  border-color: transparent !important;
}

.modalIncidentList .multiselect__tags {
  height: calc(1.5em + 0.5rem + 9px);
  padding: 0.35rem 0.5rem;
}

.modalIncidentList label {
  margin-bottom: 0;
  font-size: font-size(small);
}

.modalIncidentList .modal-dialog {
  width: 45% !important;
  margin: 0;
  position: absolute;
  right: 0;
}

.modalIncidentList .modal-body {
  padding: 0 1.1rem 0 1.1rem !important;
}

.modalIncidentList .modal-content {
  top: 50px;
  // TODO: Refactoring required for modal height
  height: calc(100vh - 78px);
  border-radius: 0;
  box-shadow: -3px 0px 10px 2px #8f8f8f !important;
}

.modalIncidentList .modal-footer {
  border-top: 0;
}

.modalIncidentList .incident-card {
    &:before {
        content: '';
        position: absolute;
        width: 3px;
        height: 100%;
        background: vt-color(red-medium);
    }
}
</style>

<style scoped>
.modalIncidentList {
  color: #303133;
}

.modalIncidentList h4 {
  font-weight: normal;
}
</style>
